import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPurchaseOrdersByDate, fetchPurchaseOrders, fetchPurchaseOrderDetail,
  fetchPurchaseOrderList, setPurchaseOrdersFilter, selectPurchaseOrder,
  resetCurrentPurchaseOrder, deletePurchaseOrder, setDefaultDays, setDefaultOfForm,
  mergePurchaseOrders, approvePendingPO, emailPO, emailPOPost, handlePoExportClick,
  handlePOUpload, resetStatus } from '../../actions/purchaseOrders_actions';
import { fetchPurchaseOrdersByFilter, finalizeSelectedReturns } from '../../actions/purchaseOrderList_actions';
import { setValue, fetchSalesCustomerDetail } from '../../actions/sales_actions';
import { printCommercialInvoicePdf, printPackingListPdf, printPurchaseOrder, printPurchaseOrderNoSubtotals } from '../../actions/print_actions';
import { fetchBaseUsers, checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import { fetchCustomers } from '../../actions/customers_actions';
import PurchaseOrderList from './GLOrderList';

const GLOrderListContainer = reduxForm({
  form: 'purchaseOrderList',
  destroyOnUnmount: false,
})(PurchaseOrderList);

const selector = formValueSelector('purchaseOrderList');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const Status = selector(state, 'Status');
  const Purchaser = selector(state, 'Purchaser');
  const ProductNum = selector(state, 'ProductNum');
  return {
    Days,
    FromDate,
    ToDate,
    Status,
    Purchaser,
    ProductNum,
    currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
    purchaseOrders: state.purchaseOrders.all,
    isLoading: state.purchaseOrders.isLoading,
    error: state.purchaseOrders.error,
    userPermissions: state.auth.userPermissions,

    purchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
    purchaseOrderDetailIsLoading: state.purchaseOrders.detailIsLoading,
    purchaseOrderDetailError: state.purchaseOrders.detailError,

    purchaseOrderList: state.purchaseOrders.purchaseOrderList,
    purchaseOrderListIsLoading: state.purchaseOrders.purchaseOrderListIsLoading,
    purchaseOrderListError: state.purchaseOrders.purchaseOrderListError,

    purchaseOrdersFilter: state.purchaseOrders.purchaseOrdersFilter,

    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,

    requestingPurchaseOrderPdf: state.print.requestingPurchaseOrderPdf,
    purchaseOrderPdf: state.print.purchaseOrderPdf,

    purchaseOrderPdfNs: state.print.purchaseOrderPdfNs,
    requestingPurchaseOrderPdfNs: state.print.requestingPurchaseOrderPdfNs,
    requestingCommercialInvoicePdf: state.print.requestingCommercialInvoicePdf,
    requestingPackingListPdf: state.print.requestingPackingListPdf,
    packingListPdf: state.print.packingListPdf,
    commercialInvoicePdf: state.print.commercialInvoicePdf,
    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
    
    mergePurchaseOrderData: state.purchaseOrders.mergePurchaseOrderData,
    mergePurchaseOrderError: state.purchaseOrders.mergePurchaseOrderError,
    mergePurchaseOrderSuccess: state.purchaseOrders.mergePurchaseOrderSuccess,
    mergePurchaseOrderLoading: state.purchaseOrders.mergePurchaseOrderLoading,

    selectedWarehouse: state.header.selectedWarehouse,
    selectedCompany: state.header.selectedCompany,

    customers: state.customers.all,
    salesShippingCustomerDetails: state.salesOrders.salesShippingCustomerDetails,
    totalPages: state.purchaseOrders.totalPages,
    totalRows: state.purchaseOrders.totalRows,
    currentPage: state.purchaseOrders.currentPage,
  };
}

export default connect(mapStateToProps, {
  fetchPurchaseOrdersByDate,
  fetchPurchaseOrderList,
  fetchPurchaseOrders,
  selectPurchaseOrder,
  resetCurrentPurchaseOrder,
  setPurchaseOrdersFilter,
  deletePurchaseOrder,
  setDefaultDays,
  fetchPurchaseOrderDetail,
  setValue,
  fetchBaseUsers,
  fetchPurchaseOrdersByFilter,
  setDefaultOfForm,
  printPurchaseOrder,
  checkPassword,
  clearCheckPassword,
  printPurchaseOrderNoSubtotals,
  mergePurchaseOrders,
  approvePendingPO,
  emailPO,
  emailPOPost,
  handlePoExportClick,
  handlePOUpload,
  finalizeSelectedReturns,
  printCommercialInvoicePdf,
  printPackingListPdf,
  fetchCustomers,
  fetchSalesCustomerDetail,
  resetStatus,
})(GLOrderListContainer);



// WEBPACK FOOTER //
// ./master/jsx/components/GL/GLOrderListContainer.jsx